import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputDropdown from '../../common/Forms/InputDropdown';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CommonDropDownStyle } from '../../ui/styled';

const CompletionRatioBAK = (props) => {
  const { cancelPopUp, setCancelPopUp, submit } = props;
  const [variant, setVariant] = useState(null);

  const handleCancel = () => {
    setCancelPopUp(false);
  };

  const variantList = [
    {'id': 1, 'value': 'Gender/Funding Source'},
    {'id': 2, 'value': 'Age'},
    {'id': 3, 'value': 'Ethnicity'},
    {'id': 4, 'value': 'Funding Source'},
  ]

  const handleSubmit = () => {
    if (variant) {
      setCancelPopUp(false);
      submit(variantList.filter(v => v.id==variant)[0]);
    }  
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={cancelPopUp}>
      <DialogTitle>
        <Typography variant="h5">
          Completion Ratio
        </Typography>  
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CommonDropDownStyle>
              <InputLabel id="variant">Group By</InputLabel>
              <Select
                labelId="variant"
                id="variant"
                value={variant}
                onChange={(event) => {
                  setVariant(event.target.value);
                }}
              >
              {
                variantList?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.value}
                    </MenuItem>
                  )                  
                })
              }  
              </Select>
            </CommonDropDownStyle>  
          </Grid>
        </Grid>    
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompletionRatioBAK;
